import React from "react";
import Index from "./index";
import StyleGuideTable from "./StyleGuideTable";

const StyleGuides = () => {
    const { styleGuides, onDelete, loading, history, search, setSearch, dispatch } = Index();

    return (
        <StyleGuideTable
            heading="All Style Guides"
            styleGuides={styleGuides}
            loading={loading}
            history={history}
            search={search}
            setSearch={setSearch}
            onDelete={onDelete}
            dispatch={dispatch}
        />
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(StyleGuides, comparisonFn);
